import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { InvoiceForm } from './InvoiceForm';
import { Button } from './ui/button';
import { ArrowLeft } from 'lucide-react';

const InvoiceEditPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  if (!id) {
    return (
      <div className="container mx-auto p-6">
        <p className="text-gray-600">Invalid invoice. Missing ID.</p>
        <Button variant="outline" onClick={() => navigate('/invoices')} className="mt-4">
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back to Invoices
        </Button>
      </div>
    );
  }

  return <InvoiceForm invoiceId={id} />;
};

export default InvoiceEditPage;
